<!--
 * @Description  : 身份认证审核 - 个人、企业
 * @Author       : 王帅
 * @Date         : 2026-05-11 15:37:14
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2026-06-18 17:47:51
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\audit-affairs-new\components\audit-identify.vue
-->
<template>
	<div class="current-main">
		<bm-panel title="#1 个人认证信息">
			<el-form :model="userForm" label-width="150px" class="view-form">
				<el-form-item label="身份证">
					<div class="flex">
						<div class="upload-item">
							<public-upload
								class="id-upload"
								isViewMode
								:viewFilesList="filterFiles('sys_user', 'idcard_1')"
								listType="picture-card"
							></public-upload>
							<div class="upload-text">人像面</div>
						</div>
						<div class="upload-item">
							<public-upload
								class="id-upload"
								isViewMode
								:viewFilesList="filterFiles('sys_user', 'idcard_2')"
								listType="picture-card"
							></public-upload>
							<div class="upload-text">国徽面</div>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="手机号">{{ userForm.phone }}</el-form-item>
				<el-form-item label="身份证号">{{ userForm.idCard }}</el-form-item>
				<el-form-item label="姓名">{{ userForm.sname }}</el-form-item>
				<el-form-item label="证明材料">
					<div style="width:600px;">
						<public-upload
							emptyOnlyShowText
							isViewMode
							:viewFilesList="filterFiles('sys_user', 'otherFile')"
							ref="otherFile"
							listType="text"
							viewHeight="60px"
						></public-upload>
					</div>
				</el-form-item>
			</el-form>
		</bm-panel>
		<!-- 企业信息 -->
		<bm-panel title="#2 企业认证信息" v-if="showCompany">
			<el-form :model="companyForm" class="custom-form" ref="userForm" label-width="150px">
				<el-form-item label="单位角色">{{ companyForm.mainType == '1002008003' ? '投标人/供应商' : '代理机构' }}</el-form-item>
				<el-form-item label="单位类型">{{ companyForm.flatTypeName }}</el-form-item>
				<el-form-item label="营业执照">
					<div class="upload-item">
						<public-upload
							class="id-upload"
							isViewMode
							:viewFilesList="filterFiles('sys_tenant_interim', 'baseInfo_1')"
							listType="picture-card"
						></public-upload>
					</div>
				</el-form-item>
				<el-form-item label="企业LOGO">
					<div class="upload-item">
						<public-upload
							class="id-upload"
							isViewMode
							:viewFilesList="filterFiles('sys_tenant_interim', 'baseInfo_2')"
							listType="picture-card"
						></public-upload>
					</div>
				</el-form-item>
				<el-form-item label="公司名称">{{ companyForm.sname }}</el-form-item>
				<el-form-item label="统一社会信用代码">{{ companyForm.creditCode }}</el-form-item>
				<el-form-item label="法人代表姓名">{{ companyForm.legal }}</el-form-item>
				<el-form-item label="认证方式">{{ companyForm.creType == 0 ? '法人信息' : '企业委托函' }} </el-form-item>
				<!-- 认证方式是法人 -->
				<template v-if="companyForm.creType == 0">
					<el-form-item label="法人身份证号">{{ companyForm.legalNo }}</el-form-item>
					<el-form-item label="法人手机号">{{ companyForm.legalPhone }}</el-form-item>
				</template>
				<!-- 认证方式是代理 -->
				<template v-if="companyForm.creType == 1">
					<el-form-item label="企业委托书">
						<div class="upload-item">
							<public-upload
								class="id-upload"
								isViewMode
								:viewFilesList="filterFiles('sys_tenant_interim', 'baseInfo_3')"
								listType="picture-card"
							></public-upload>
						</div>
					</el-form-item>
					<el-form-item label="代理人身份证">
						<div class="flex">
							<div class="upload-item">
								<public-upload
									class="id-upload"
									isViewMode
									:viewFilesList="filterFiles('sys_tenant_interim', 'baseInfo_5')"
									listType="picture-card"
								></public-upload>
								<div class="upload-text">身份证（人像面）</div>
							</div>
							<div class="upload-item">
								<public-upload
									class="id-upload"
									isViewMode
									:viewFilesList="filterFiles('sys_tenant_interim', 'baseInfo_4')"
									listType="picture-card"
								></public-upload>
								<div class="upload-text">身份证（国徽面）</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="代理人手机号">{{ companyForm.agentPhone }}</el-form-item>
				</template>
				<el-form-item label="注册地址">{{ companyForm.registAdd }}</el-form-item>
				<el-form-item label="证明材料">
					<div style="width:600px">
						<public-upload
							emptyOnlyShowText
							isViewMode
							:viewFilesList="filterFiles('sys_tenant_interim', 'otherFile')"
							ref="otherFile_company"
							listType="text"
							viewHeight="60px"
						></public-upload>
					</div>
				</el-form-item>
			</el-form>
		</bm-panel>
		<!-- 个人认证审核 -->
		<bm-panel :title="`#${showCompany ? 3 : 2} 审核信息`">
			<el-form :model="resultForm" ref="resultForm" label-width="150px" :rules="resultRules">
				<el-form-item label="自动审核结果">
					<div class="info-content">
						<p class="info-row" v-for="(item, index) in autoResults" :key="'result' + index">{{ item }}</p>
					</div>
				</el-form-item>
				<el-form-item label="审核结果" prop="status">
					<el-select v-model="resultForm.status" placeholder="请选择" v-if="mode != 'view'">
						<el-option label="通过" :value="1"></el-option>
						<el-option label="驳回" :value="2"></el-option>
					</el-select>
					<div v-else>{{ resultForm.status == 1 ? '通过' : '驳回' }}</div>
				</el-form-item>
				<el-form-item label="审核意见" prop="remark">
					<el-input
						type="textarea"
						v-model="resultForm.remark"
						maxlength="200"
						show-word-limit
						:autosize="{ minRows: 5 }"
						v-if="mode != 'view'"
					></el-input>
					<div class="info-text" v-else>{{ resultForm.remark }}</div>
				</el-form-item>
				<template v-if="mode == 'view'">
					<el-form-item label="审核人">{{ resultForm.upUserSname }}</el-form-item>
					<el-form-item label="审核时间">{{ resultForm.updateDate }}</el-form-item>
				</template>
			</el-form>
		</bm-panel>
	</div>
</template>

<script>
// api
import { getRecordDetail } from 'api/modules/audit'
import { auditSubmit } from 'api/modules/invoice'

// components
import bmPanel from '@/components/panel/Panel'
export default {
	name: '',
	components: { bmPanel },
	props: {
		rowData: {
			type: Object,
			deafault: () => {
				return {}
			}
		},
		mode: {
			type: String,
			default: ''
		},
		// 是否展示企业
		showCompany: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			userForm: {},
			companyForm: {},
			autoResults: [], // 自动审核结果
			viewFilesList: [],
			resultForm: {
				status: '',
				remark: ''
			},
			resultRules: {
				status: [{ required: true, message: '不能为空', trigger: 'change' }],
				remark: [{ required: true, message: '不能为空', trigger: 'blur' }]
			}
		}
	},
	methods: {
		//* 初始获取信息
		getDetailInfo() {
			this.viewFilesList = []
			getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				if (this.showCompany) {
					this.userForm = res.data.userInfo
					this.companyForm = res.data.tenantInfo

					let baseFiles = res.data.userInfo.baseFiles || []
					let zmFiles = res.data.userInfo.zmFiles || []
					this.viewFilesList = baseFiles.concat(zmFiles).concat(res.data.tenantInfo.files)
				} else {
					this.userForm = res.data
					let zmFiles = res.data.zmFiles || []
					this.viewFilesList = res.data.baseFiles.concat(zmFiles)
				}

				if (this.mode == 'view' && res.data.applyRecords.length > 0) {
					this.resultForm = res.data.applyRecords[0]
				}
			})
		},

		//! 附件数组判断
		filterFiles(tableName, assortmrnt) {
			return this.viewFilesList.filter((x) => x.tableName == tableName && x.assortment == assortmrnt)
		},

		//TODO 确认提交
		doSubmit() {
			this.$refs.resultForm.validate((valid) => {
				if (valid) {
					auditSubmit({
						id: this.rowData.id,
						busId: this.rowData.busId,
						busType: this.rowData.busType,
						status: this.resultForm.status,
						remark: this.resultForm.remark
					})
						.then((res) => {
							this.$message.success('审核完成')
							this.$emit('close', '1')
						})
						.catch(() => {
							this.$emit('btnClose')
						})
				} else {
					this.$emit('btnClose')
				}
			})
		}
	},
	created() {
		console.log('this.mode', this.mode)
		this.getDetailInfo()
		this.autoResults = this.rowData.autoResults.split(',')
	},
	computed: {}
}
</script>
<style scoped lang="less">
.upload-item {
	width: 200px;
	margin-right: 20px;
	text-align: center;
}
.view-form /deep/ .el-form-item {
	margin-bottom: 0;
}

.info-content {
	padding: 8px 0;
	line-height: 24px;
	color: #cf000d;
}
</style>
